'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.includes')
require('core-js/modules/es.array.slice')
require('core-js/modules/es.date.to-string')
require('core-js/modules/es.object.to-string')
require('core-js/modules/es.regexp.exec')
require('core-js/modules/es.regexp.to-string')
require('core-js/modules/es.string.includes')
require('core-js/modules/es.string.replace')
exports.__esModule = true
exports.toTensStr = toTensStr
exports.dateToStr = dateToStr
exports.default = void 0
var _is = require('../is')
var _str = require('../str')
var _obj = require('../obj')
var _convert = _interopRequireDefault(require('./convert'))
var _getters = require('./getters')
var _consts = require('./consts')

/**
 * toTensStr
 * Делает строку из числа, плюч добавляет 0 впереди, если число меньше 10
 *
 * @param {number} num
 * @example
 * toStr( 59 ) // '59'
 * toStr( 1 ) // '01'
 * @returns {string}
 * @memberof Time
 */
function toTensStr(num) {
  return num < 10 ? '0' + num : '' + num
}

/*
    Mask:
  
    h: 01
    m: 01
    s: 01
    D: Пн | Понедельник | 1
    d: 01
    M: Янв | Январь | 0
    y: 19
    Y: 2019
  */

var maskChars = ['h', 'm', 's', 'D', 'd', 'M', 'y', 'Y']

function replaceTrsForDayNmonth(num, trsObj) {
  var trs = trsObj[num.toString()]
  return (0, _str.castStr)(trs, toTensStr(num + 1))
}

var defOptsType = {
  mask: _consts.DEFAULT_FMT_MASK
}

function dateToStr(dateArg, optsArg) {
  var date = _convert.default.fromWhatever(dateArg)
  if ((0, _is.isNull)(date)) {
    return { isStringified: false, value: '' }
  }

  var opts = (0, _is.isObj)(optsArg) ? optsArg : defOptsType
  var mask = (0, _str.castStr)(opts.mask, _consts.DEFAULT_FMT_MASK)
  var monthTrs = (0, _obj.castObj)(opts.monthTrs)
  var daysTrs = (0, _obj.castObj)(opts.daysTrs)

  var value = mask

  maskChars.forEach(function(partChar) {
    if (value.includes(partChar)) {
      switch (partChar) {
        case 'h':
        case 'm':
        case 's':
        case 'd':
          value = value.replace(partChar, toTensStr((0, _getters.get)(date, partChar)))
          break
        case 'Y':
          value = value.replace(partChar, (0, _getters.get)(date, 'y').toString())
          break
        case 'y':
          value = value.replace(
            partChar,
            (0, _getters.get)(date, 'y')
              .toString()
              .slice(2)
          )
          break
        case 'D':
          value = value.replace(partChar, replaceTrsForDayNmonth((0, _getters.get)(date, 'D'), daysTrs))
          break
        case 'M':
          value = value.replace(partChar, replaceTrsForDayNmonth((0, _getters.get)(date, 'M'), monthTrs))
          break
        default:
          break
      }
    }
  })

  return { isStringified: true, value: value }
}

var fmt = {
  toTensStr: toTensStr,
  dateToStr: dateToStr
}
var _default = fmt
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/fmt.js
// module id = 218
// module chunks = 0